import React, { useState } from "react";
import "../../../Assets/CSS/bulkorder.css";
import "../oms.css";

import Up from "../../../Assets/Images/OMS/up.svg";
import Down from "../../../Assets/Images/OMS/down.svg";
import AddMore from "../../../Assets/Images/OMS/AddMore.svg";
import Supplier from "../../../Assets/Images/OMS_New/payment (1).svg";
import { useFormik } from "formik";
import { Button } from "@mui/material";

import AddNewPaymentDetails from "../AddNewPaymentDetails";

import moment from "moment";

function PaymentDetailSupplierForm({
  paymentData,
  getOMSData,
  orderId,
  omsData,
}) {
  const [openPayment, setOpenPayment] = useState(false);

  let jsonArray = [];
  try {
    jsonArray = paymentData?.supplier_transferred_data?.map((jsonString) =>
      JSON.parse(jsonString)
    );
  } catch {
    // No action
  }

  const handleOpenPayment = () => {
    setOpenPayment(true);
  };
  const handleClosePayment = () => {
    setOpenPayment(false);
  };

  const [supplierPaymentDetails, setSupplierPaymentDetails] = useState(false);

  const initialValues = {
    supplier_Name: "",
    billed_to: "",
    // field_Executive: "",
    // sales_Person: "",
    // pO_Date: "",
    // pO_Number: "",
    // address_Line1: "",
    // address_Line2: "",
    // city_state: "",
    // pinCode: "",
    // gSTNumber: "",
    // PAN: "",
    // contact_No: "",
    // bank_Ac_No: "",
    // branch: "",
    // IFSC_Code: "",
  };
  const validate = (values) => {
    const errors = {};

    return errors;
  };
  const formik = useFormik({
    initialValues: { supplier_Name: "", billed_to: "" },
    validate,
    onSubmit: (values) => {
      console.log(values);
    },
  });

  const returnPaymentStatus = (totalCp, supplierTransferAmount) => {
    let actualAmount = parseFloat(totalCp) - 0.01 * parseFloat(totalCp);
    if (parseFloat(supplierTransferAmount).toFixed(2) === 0) {
      return "Pending";
    } else if (
      actualAmount.toFixed(2) <= parseFloat(supplierTransferAmount).toFixed(2)
    ) {
      return "Fully Paid";
    } else {
      return "Partially Paid";
    }
  };

  //  Get Inventory Data
  return (
    <div className="">
      <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
        <div className="flex flex-col sm:flex-row justify-between">
          <div className="font-medium text-cyan-950 text-md flex gap-1">
            <img src={Supplier} alt="" />
            <div className="ms-1">Payment Details</div>
            {omsData?.order_type === "LR" && omsData?.supplier_loading && (
              <Button className="m-0 p-0" onClick={() => handleOpenPayment()}>
                <img src={AddMore} alt="" />{" "}
                <span className="ml-2 normal-case">Payment Request</span>
              </Button>
            )}
          </div>
          <div>
            {supplierPaymentDetails ? (
              <div className="font-medium text-cyan-950 text-lg mt-2">
                <img
                  src={Up}
                  alt=""
                  role="button"
                  onClick={() =>
                    setSupplierPaymentDetails(!supplierPaymentDetails)
                  }
                />
              </div>
            ) : (
              <div className="font-medium text-cyan-950 text-lg mt-2">
                <img
                  src={Down}
                  alt=""
                  role="button"
                  onClick={() =>
                    setSupplierPaymentDetails(!supplierPaymentDetails)
                  }
                />
              </div>
            )}
          </div>
        </div>
        <div>
          <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
        </div>
        <div>
          {supplierPaymentDetails ? (
            <></>
          ) : (
            <div>
              {!jsonArray || jsonArray?.length === 0 ? (
                <div className="mb-3 mt-3">No Payment Details Available</div>
              ) : (
                jsonArray?.map((each, index) => (
                  <div key={index} className="mb-3 border border-3 p-2">
                    <h1 className="text-sm mb-3">Payment {index + 1}</h1>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                      <div>
                        <label
                          for="date"
                          className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                        >
                          Date
                        </label>
                        <input
                          type="text"
                          id="date"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="date"
                          value={
                            each?.date
                              ? moment(each?.date).format("DD-MM-YYYY")
                              : "NA"
                          }
                          disabled
                        />
                      </div>
                      <div>
                        <label
                          for="amount"
                          className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                        >
                          Amount (Rs)
                        </label>
                        <input
                          type="text"
                          id="amount"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="amount"
                          value={each?.amount}
                          disabled
                        />
                      </div>
                      <div>
                        <label
                          for="payment_status"
                          className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                        >
                          Payment Status
                        </label>
                        <input
                          type="text"
                          id="payment_status"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="payment_status"
                          value={returnPaymentStatus(
                            paymentData?.total_cp || 0,
                            paymentData?.supplier_total_transfer_amt || 0
                          )}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>

      <AddNewPaymentDetails
        open={openPayment}
        handleClose={handleClosePayment}
        getOMSData={getOMSData}
        orderId={orderId}
      />
    </div>
  );
}

export default PaymentDetailSupplierForm;
